import $ from 'jquery'
import './tabs';

$(function() {
	$('.quiz .submit button').on('click', function(){
		var button = $(this);
		var quizTab = button.parent().parent();
		var correctAnswer = quizTab.find('.correct-option').val();
		var selectedAnswer = quizTab.find('.answers').find('input:checked').val();
		var results  = quizTab.find('.results');
		var question = quizTab.find('.question');
		var answers = quizTab.find('.answers');
		var answerIndicators = $('.results-panel');
		var correct = $('.result-panel.correct');
		var wrong = $('.result-panel.wrong');
		answerIndicators.hide();
		results.hide();
		question.show();
		answers.show();
		button.show();
		if (correctAnswer == selectedAnswer) {
			console.log('correct');
			correct.show();
			results.show();
			question.hide();
			answers.hide();
			button.hide();
			
		} else if (selectedAnswer == null) {
			// nothing
		}
		else {
			console.log('not correct');
			wrong.show();
			results.show();
			question.hide();
			answers.hide();
			button.hide();
		}
	});
	$('.excercise-section .tabs-nav').find('li:first-child').addClass('active');
	$('.tabs-nav').find('li:first-child').addClass('first');
	$('.tabs-nav').find('li:last-child').addClass('last');
	$('#btnPrevious').on('click', function(){
  		var selectedTab = $('li.active');
		var prevTab = selectedTab.prev('li');
		var nextBtn = $('#btnNext');
		prevTab.trigger("click");
		if (prevTab.hasClass('first')) {
			$(this).addClass('inactive');
			nextBtn.removeClass('inactive');
		} else if (selectedTab.hasClass('first')) {
			//do nothing
		} else {
			$(this).removeClass('inactive');
		}
		return false;
	});
	$('#btnNext').on('click', function(){
		var selectedTab = $('li.active');

		var nextTab = selectedTab.next('li');
		var prevBtn = $('#btnPrevious');
		nextTab.trigger("click");
		if (nextTab.hasClass('last')) {
			$(this).addClass('inactive');
			prevBtn.removeClass('inactive');
		} else if (selectedTab.hasClass('last')) {
			//do nothing
		} else {
			$(this).removeClass('inactive');
		}
		return false;
	});
});